import React, { useState, useEffect } from 'react';

const Preloader = (props) => {
    return (
        <React.Fragment>
            <div class="loader">
                <div></div> 
                <div></div>
                <div></div>
                <div></div>
            </div>
        </React.Fragment>
    );
}


export default Preloader;
